module.exports = __webpack_public_path__ + "media/images/general/brands/master-8016b9fa3eed47c50f9900919a241ec0.png";